import { render, staticRenderFns } from "./sokulemeyen.vue?vue&type=template&id=5a6f569b"
import script from "./sokulemeyen.vue?vue&type=script&lang=js"
export * from "./sokulemeyen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports